// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider {
    width: 100%;
}

.sliderText {
    width: 50px;
    height: 48px;
}


/*::ng-deep .ui-slider-range {
    background-color: #C4DBEE !important;
}*/

/*/deep/.mat-accent .mat-slider-thumb {
    background-color: var(--primary-color) !important;
}

::ng-deep .mat-accent .mat-slider-track-fill {
    background-color: var(--primary-color) !important;
}*/`, "",{"version":3,"sources":["webpack://./src/app/components/controls/tables/columnvisibility/columnvisibility.control.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;;AAGA;;EAEE;;AAEF;;;;;;EAME","sourcesContent":[".slider {\n    width: 100%;\n}\n\n.sliderText {\n    width: 50px;\n    height: 48px;\n}\n\n\n/*::ng-deep .ui-slider-range {\n    background-color: #C4DBEE !important;\n}*/\n\n/*/deep/.mat-accent .mat-slider-thumb {\n    background-color: var(--primary-color) !important;\n}\n\n::ng-deep .mat-accent .mat-slider-track-fill {\n    background-color: var(--primary-color) !important;\n}*/"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
